import { XIcon } from "@heroicons/react/solid";
import axios from "axios";
import React, { useContext } from "react";
import { PuffLoader } from "react-spinners";
import { toast } from "react-toastify";
import backendService from "../services.js/backendService";
import { SocketContext } from "../services.js/socket";
import FriendList from "./FriendList";


function ForwardMessageModal({
  openForwardMessageModal,
  messageId,
  getForwardMessage,
}) {
  const [selectedMembers, setSelectedMembers] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const socket = useContext(SocketContext);
  const getFriendList = (data) => {
    setSelectedMembers(data);

 
  };
  const forwardMessage = async () => {
    setLoading(true);
    const createdAt = new Date();
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}/forwardmessage`,
        {
          users: selectedMembers,
          messageId: messageId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        }
      );
      selectedMembers.forEach((user) => {
  
        const msg = {
          senderId: backendService.getLoggedInUser()._id,
          receiverId: user._id,
          content: res.data.message.content,
          contentType: res.data.message.contentType,
          conversationId: res.data.message.conversationId,
          status: "sending",
          data: res.data.message.data,
          createdAt: createdAt,
        };
        socket.emit("sendMessage", msg);
      });
      getForwardMessage(res.data.message);
      toast.success("Message forwarded successfully");
      setLoading(false);
      openForwardMessageModal(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none   ">
        <div className="w-11/12 sm:w-3/4 md:w-1/2 lg:w-1/3 relative my-6 mx-auto max-w-lg rounded-md">
          {/*content*/}
          <div className="border-0 rounded-lg shadow-md shadow-black relative flex flex-col w-full  outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start bg-background justify-between pt-5 px-5  rounded-t">
            {loading ? (
                // <BallTriangle stroke="#000000" height={"1.5em"} />
                <div className="flex w-fitems-center justify-center text-primary">
                  <PuffLoader size={30} color={"#000"} loading={loading} />
                  <h3 className="text-xl font-robo text-primary ">
                    Forwarding ...
                  </h3>
                </div>  
              ) : (
                <h3 className="text-xl font-robo text-primary ">
                  Forward Message 
                </h3>
              )}
              <div className="h-7 w-7 flex items-center justify-center cursor-pointer hover:bg-palette_color1 hover:text-palette_color2 text-palette_color1 hover:rounded-full">
                <XIcon
                  className="h-5 w-5 "
                  aria-hidden="true"
                  onClick={() => openForwardMessageModal(false)}
                />
              </div>
            </div>
            {/*body*/}
            <div className="relative p-3 sm:p-6 flex-auto bg-background">
              <form action="#" method="POST">
                <div className="col-span-6 sm:col-span-3">
                  <div className="w-[100%]">
                    <div className="flex items-center">
                      <label className="block text-md font-robo text-primary ">
                        Select Friends
                      </label>
                    </div>
                    <FriendList friendList={getFriendList} />
                  </div>
                </div>
              </form>
            </div>
            {/*footer*/}
            <div className="flex items-center bg-background justify-end  pb-3 pr-6  rounded-b">
              <button
                className="bg-palette_color1 border-[1px] border-palette_color1 mt-1 hover:bg-palette_color2 text-white hover:text-palette_color1  font-robo uppercase text-md  px-8 py-1 rounded shadow-sm hover:border hover:border-palette_color1  ease-linear transition-all duration-500"
                type="button"
                disabled={loading}
                onClick={async () => {
                  if (selectedMembers.length > 0) {
                    await forwardMessage();
                  } else {
                    alert("Please select atleast one friend");
                  }
                }}
              >
                
                Forward Message
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
}

export default ForwardMessageModal;
